import * as React from 'react';
import { History } from 'history';
import Model from './owner-model';
import BaseList from '../base/base-list.component';

interface IProps {  
  history: History;
  root?: string;
}

interface IState {
}

export default class OwnerList extends React.Component<IProps, IState> {
  public render(): React.ReactNode {
    return (
      <BaseList history={this.props.history} url={(this.props.root || '') + Model.url} model={Model}/>
    );
  }
}
